// extracted by mini-css-extract-plugin
var _1 = "DesktopProductModal_container__95fE5";
export { _1 as "container" }
